import React from 'react'
import BotUnderKey from '../../../../elements/botUnderKey/botUnderKey'
import BotPrice from '../../../../elements/botPrice/botPrice'
import './botDevelopment.css'
import BotTarifs from '../../../../elements/botTarifs/botTarifs'

const BotDevelopment = () => {
  return (
    <div className="botDevelopmentDiv">
        <BotUnderKey/>
        <BotTarifs/>
    </div>
  )
}

export default BotDevelopment